export const STATUSES = Object.freeze({ Pending: false, Submitted: true });

export const COLORS = Object.freeze({
  [STATUSES.Pending]: '#DDB3D7',
  [STATUSES.Submitted]: '#FAE76F',
});
